<template>
  <div class="account-management">
    <div class="toolbar">
      <h2>
        <em></em>
        <span>{{$t("accountInfo.title")}}</span>
      </h2>
    </div>
    <div class="com-container">
      <table class="act-ifmTable">
        <tr>
          <td class="tab-tit" width="210">{{$t("accountInfo.username")}}</td>
          <td>{{username}}</td>
        </tr>
        <tr>
          <td class="tab-tit">{{$t("accountInfo.email")}}</td>
          <td>{{email}}</td>
        </tr>
        <tr>
          <td class="tab-tit">{{$t("accountInfo.registerDate")}}</td>
          <td>{{created}}</td>
        </tr>
        <tr>
          <td class="tab-tit">{{$t("accountInfo.status")}}</td>
          <td>{{status}}</td>
        </tr>
        <tr>
          <td class="tab-tit">{{$t("accountInfo.lastDate")}}</td>
          <td>{{time}}</td>
        </tr>
        <tr>
          <td class="tab-tit">{{$t("accountInfo.lastIp")}}</td>
          <td>{{ip}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import api from "../../api/api";
import { formatTime, formatIp } from "../../common/utils";
var resCode = require("../../../server/common/data").resCode;

export default {
  data() {
    return {
      username: "",
      email: "",
      created: "",
      status: "",
      time: "",
      ip: ""
    };
  },
  beforeMount() {
    api.getUser({})
    .then(res => {
      if (res.data.CODE === resCode.SUCCESS) {
        let data = res.data.DATA;
        this.username = data.username;
        this.email = data.email;
        this.created = formatTime(data.created, "YYYY-MM-DD HH:mm:ss");
        if (data.status === "disabled") {
          this.status = this.$t('common.statusDisabled');
        } else {
          this.status = this.$t('common.statusNormal');
        }
        if ((data.trace !== null) && (data.trace.length >= 2)) { // show last login
          let index = data.trace.length - 2;  
          this.time = formatTime(data.trace[index].time, "YYYY-MM-DD HH:mm:ss");
          this.ip = formatIp(data.trace[index].ip);
        } else {
          this.time = "";
          this.ip = "";
        }
      }
    })
    .catch(err => {});
  }
};
</script>
<style lang="scss">
.account-management {
  .act-ifmTable {
    width: 96%;
    margin: 80px 2% 0;
    border-collapse: collapse;
    border-bottom: solid 1px #ebf0f6;
    font-size: 14px;
    tr {
      width: 100%;
      height: 60px;
      td {
        color: #606e85;
        text-indent: 20px;
        border-radius: 4px;
      }
    }
    tr:nth-last-child(even) {
      background-color: #f4f7f9;
    }
    tr td:nth-last-child(2) {
      font-weight: bold;
    }
  }
}
</style>




// WEBPACK FOOTER //
// AccountInformation.vue?1d35f7f6